import { Link, Outlet, useLocation } from "react-router-dom";

import { AppHeader, isNavItemActive, type HeaderNavItem } from "@vellum/ui";
import { useAuth } from "@vellum/micro-app-auth";

import { isAdmin } from "@/lib/auth/roles";

const NAV_ITEMS: { label: string; href: string }[] = [
  { label: "Dispatch", href: "/dispatch" },
  { label: "Coverage", href: "/coverage" },
  { label: "Facilities", href: "/facilities" },
  { label: "Companies", href: "/companies" },
  { label: "Users", href: "/users" },
];

// Pages that need the whole window (maps) opt out of the reading-width column.
const FULL_WIDTH_PATHS = ["/coverage", "/dispatch"];

export function RootLayout() {
  const { user } = useAuth();
  const location = useLocation();

  const navItems: HeaderNavItem[] = isAdmin(user)
    ? NAV_ITEMS.map((item) => ({
        ...item,
        active: isNavItemActive(location.pathname, item.href),
      }))
    : [];

  const fullWidth = FULL_WIDTH_PATHS.some((path) =>
    isNavItemActive(location.pathname, path),
  );

  return (
    <div className="flex min-h-screen flex-col">
      <AppHeader
        brand="Vellum Admin"
        accent="amber"
        renderLink={({ href, className, children }) => (
          <Link to={href} className={className}>
            {children}
          </Link>
        )}
        navItems={navItems}
        showLogo
      />
      <main
        className={`mx-auto w-full flex-1 px-4 sm:px-6 lg:px-8 ${fullWidth ? "max-w-[1600px] py-4" : "max-w-6xl py-6 pb-10 sm:py-8 sm:pb-12"}`}
      >
        <Outlet />
      </main>
    </div>
  );
}
